export enum EApplicationAccess {
  Allow,
  Denied
}
